export const viewMyPickupScheduleData = [
  {
    Question: `Where can I view my pickup schedule?`,
    Answer: `To view your pickup schedule, simply click on <strong>My WM</strong> from the menu and either log in or continue as a guest. 

        From the My WM Dashboard, go to <strong> My Services. Pickup Schedule</strong> will be displayed, along with the next pickup date, holiday schedule, and other service requests. 
        
        <strong>Note:</strong> Waste collection services typically occur between 5 a.m. and 6 p.m. local time. Make sure the lid on your container is completely closed so our drivers can service them safely.`,
  },
]
